/** DHL Ship API warning codes when paperless invoice is not supported for the destination. */
export const DHL_CUSTOMS_INVOICE_WARNING_CODES = ['7988'] as const;

const DHL_CUSTOMS_INVOICE_WARNING_CODE_SET = new Set<string>(DHL_CUSTOMS_INVOICE_WARNING_CODES);

const isRecord = (value: unknown): value is Record<string, unknown> =>
    typeof value === 'object' && value !== null && !Array.isArray(value);

const parseJsonIfString = (value: unknown): unknown => {
    if (typeof value !== 'string') {
        return value;
    }
    try {
        return JSON.parse(value) as unknown;
    } catch {
        return null;
    }
};

const extractWarningCode = (warning: string): string | null => {
    const colonIndex = warning.indexOf(':');
    const code = colonIndex >= 0 ? warning.slice(0, colonIndex).trim() : warning.trim();
    return code.length > 0 ? code : null;
};

export const hasDhlCustomsInvoiceWarning = (warnings: string[] | undefined): boolean => {
    if (!warnings?.length) {
        return false;
    }

    return warnings.some((warning) => {
        const code = extractWarningCode(warning);
        return code !== null && DHL_CUSTOMS_INVOICE_WARNING_CODE_SET.has(code);
    });
};

export const getDhlShipmentResponseWarnings = (rawData: unknown): string[] | undefined => {
    const parsed = parseJsonIfString(rawData);
    if (!isRecord(parsed)) {
        return undefined;
    }

    const warnings = parsed.warnings;
    if (!Array.isArray(warnings)) {
        return undefined;
    }

    const normalizedWarnings = warnings.filter((warning): warning is string => typeof warning === 'string');
    return normalizedWarnings.length > 0 ? normalizedWarnings : undefined;
};

export const hasDhlCustomsInvoiceWarningInShipResponseRawData = (rawData: unknown): boolean =>
    hasDhlCustomsInvoiceWarning(getDhlShipmentResponseWarnings(rawData));
